import {
  EnhancedCheckboxRHF,
  RHookFormNumberFieldWithLabel,
} from "@websential/cosmic-v20";

import { FC } from "react";
import { Grid } from "@mui/material";

interface ITaxCreditsSetupFieldsPanel {
  employeeDataById: any;
}
export const TaxCreditsSetupFieldsPanel: FC<ITaxCreditsSetupFieldsPanel> = ({
  employeeDataById,
}) => {
  return (
    <>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
        <RHookFormNumberFieldWithLabel
          id={
            "otherFederalTaxCreditsAuthorizedByTaxCenterMedicalExpensesChartiableDonations"
          }
          testId={
            "otherFederalTaxCreditsAuthorizedByTaxCenterOrMedicalExpe-nsesOrCharitibleDonations"
          }
          label={
            "Other Federal Tax Credits Authorized by Tax Center, Medical expenses, charitible donations"
          }
        />

        <RHookFormNumberFieldWithLabel
          id={
            "otherAnnualProvincialNonRefundableTaxCreditsAuthorizedByTaxCenter"
          }
          testId={
            "otherAnnualProvincialNonRefundableTaxCreditsAuthorizedByTaxCenter"
          }
          label={
            "Other Annual Provincial Non-Refundable Tax Credits Authorized by Tax Center"
          }
        />
        <RHookFormNumberFieldWithLabel
          id={
            "boughtApprovedSharesOfCapitalStockOfAPrescribedLaborSponsoredVentureCapitalCorp"
          }
          testId={
            "boughtApprovedSharesOfCapitalStockOfAPrescribedLaborSponsoredVentureCapitalCorp"
          }
          label={
            "Bought Approved Shares of Capital Stock of a Prescribed Labor-Sponsored Venture Capital Corp."
          }
        />
        {employeeDataById &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode ===
          "QC" && (
            <RHookFormNumberFieldWithLabel
              id={
                "contributionToTheFondsDeSolidariteDesTravailleursDuQuebecFTQOrToFondaction"
              }
              testId={
                "contributionToTheFondsDeSolidariteDesTravailleursDuQuebecFTQOrToFondaction"
              }
              label={
                "Contribution to the Fonds de solidarite des travailleurs du Quebec (FTQ) or to Fondaction"
              }
            />
          )}
        <RHookFormNumberFieldWithLabel
          id={"numberOfDisabledDependants"}
          testId={"numberOfDisabledDependants"}
          label={"Number of Disabled Dependants"}
        />
        <RHookFormNumberFieldWithLabel
          id={
            "noOfDependantsUnderAge18ForWhichTheEmployeeOrHasMadeAWrittenRequest"
          }
          testId={
            "noOfDependantsUnderAge18ForWhichTheEmployeeOrHasMadeAWrittenRequest"
          }
          label={
            "No. of Dependants under age 19 for which the employee or pensioner has made a written request"
          }
        />
        {employeeDataById &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode ===
          "QC" && (
            <RHookFormNumberFieldWithLabel
              id={"annualDeductionAuthorizedInFormTp1016V"}
              testId={"annualDeductionAuthorizedInFormTp1016V"}
              label={"Annual deduction authorized in form TP-1016-V"}
            />
          )}
        {employeeDataById &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode &&
          employeeDataById.employeePayroll.provinceOfEmployment.shortCode ===
          "QC" && (
            <EnhancedCheckboxRHF
              name="tp1016VFilledBeforeFirstPeriodInTheYear"
              checked={false}
              testId="tp1016VFilledBeforeFirstPeriodInTheYear"
              checkboxLabel="TP-1016-V filled before first period in the year"
            />
          )}
      </Grid>
    </>
  );
};
